(function () {
  function formatMoney(cents) {
    const fmt = (window.Shopify && window.Shopify.money_format) || "${{amount}}";
    const v = Number(cents || 0) / 100;
    const amount = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // Horizon a veces pone "$17.99 USD" como texto simple; aquí devolvemos "$17.99"
    return fmt
      .replace("{{amount}}", amount)
      .replace("{{amount_with_comma_separator}}", amount)
      .replace("{{amount_no_decimals}}", Math.round(v).toString())
      .replace("{{amount_no_decimals_with_comma_separator}}", Math.round(v).toString());
  }

  function wirePicker(cardEl) {
    const select = cardEl.querySelector(".pc-variant-select");
    if (!select) return;

    const sync = () => {
      const variantId = select.value;

      // 0) lee data del <option> seleccionado
      const opt = select.options[select.selectedIndex];
      const priceCents = opt?.dataset.price;       // viene de data-price en Liquid
      const compareCents = opt?.dataset.compareAt; // data-compare-at

      // ✅ A) actualizar precio visible (Horizon)
      // En tu DOM: <product-price> ... <span class="price">$17.99 USD</span>
      if (priceCents) {
        const priceSpan =
          cardEl.querySelector("product-price span.price") ||
          cardEl.querySelector("span.price");

        if (priceSpan) {
          // Mantiene el "USD" si ya existe en el texto
          const hasUSD = /\bUSD\b/.test(priceSpan.textContent || "");
          priceSpan.textContent = hasUSD
            ? `${formatMoney(priceCents)} USD`
            : formatMoney(priceCents);
        }
      }

      // (Opcional) compare-at si lo querés mostrar luego:
      // si en tu tema existe algún nodo para compare price, lo conectamos.

      // 1) actualiza local-pickup
      cardEl.querySelectorAll("local-pickup").forEach((el) => {
        el.setAttribute("data-variant-id", variantId);
        el.dataset.variantId = variantId;
      });

      // 2) add-to-cart-component o botón
      cardEl.querySelectorAll("add-to-cart-component").forEach((el) => {
        el.setAttribute("data-variant-id", variantId);
        el.dataset.variantId = variantId;
      });

      const btn = cardEl.querySelector('button[ref="addToCartButton"]');
      if (btn) {
        btn.setAttribute("data-variant-id", variantId);
        btn.dataset.variantId = variantId;
      }

      // 3) hidden input name="id" (y dispara change por si el tema escucha eventos)
      cardEl.querySelectorAll('input[name="id"]').forEach((inp) => {
        inp.value = variantId;
        inp.dispatchEvent(new Event("change", { bubbles: true }));
        inp.dispatchEvent(new Event("input", { bubbles: true }));
      });
    };

    sync();
    select.addEventListener("change", sync);

    cardEl.addEventListener(
      "click",
      (e) => {
        if (e.target && e.target.closest('button[ref="addToCartButton"]')) {
          sync();
        }
      },
      true
    );
  }

  function init() {
    document.querySelectorAll("product-card").forEach(wirePicker);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();